import React from 'react'
import styled from 'styled-components'

import { spaces } from '@/config/global-parameters'

import FilterInput, { InputStyled } from '../../FilterInput'
import MultiSelectionButton from '../../MultiSelectionButton'

interface ISearchFilter {
  className?: string
  onChangeInputFilter: (value: string) => void
  changeSelectedUnit: () => void
  selectedUnit: string
}

const SearchFilter = ({
  changeSelectedUnit,
  className,
  onChangeInputFilter,
  selectedUnit,
}: ISearchFilter) => {
  const regionInput = (
    <FilterInput
      onChange={onChangeInputFilter}
      placeholder="Filtrar"
    />
  )

  const regularSearchFilter = (
    <RegularSearchFilter>
      {regionInput}
      <MultiSelectionButton
        changeSelectedUnit={changeSelectedUnit}
        options={[
          { key: 'porcentaje', label: 'PORCENTAJE' },
          { key: 'cantidad', label: 'CANTIDAD' },
        ]}
        selectedOption={selectedUnit}
      />
    </RegularSearchFilter>
  )

  const mobileSearchFilter = (
    <MobileSearchFilter>
      <MobileBottomWrapper>
        {regionInput}
        <DatatypeSelector
          changeSelectedUnit={changeSelectedUnit}
          options={[
            { key: 'porcentaje', label: '%' },
            { key: 'cantidad', label: 'Nº' },
          ]}
          selectedOption={selectedUnit}
        />
      </MobileBottomWrapper>
    </MobileSearchFilter>
  )
  return (
    <Wrapper className={className}>
      {regularSearchFilter}
      {mobileSearchFilter}
    </Wrapper>
  )
}

const RegularSearchFilter = styled.div`
  display: contents;
`
const MobileSearchFilter = styled.div`
  display: contents;
`

const DatatypeSelector = styled(MultiSelectionButton)`
  width: 70px;
`

const MobileBottomWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`

const Wrapper = styled.div`
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 12px;
  ${RegularSearchFilter} {
    display: contents;
  }
  ${MobileSearchFilter} {
    display: none;
  }
  @media (max-width: ${spaces.tabletBreakpoint}) {
    flex-direction: column;
    align-items: center;
    ${RegularSearchFilter} {
      display: none;
    }
    ${MobileSearchFilter} {
      display: contents;
    }
    & ${InputStyled} {
      width: 70px;
    }
  }
`

export default SearchFilter
